import React, { useState } from 'react';
import { Image, Play } from 'lucide-react';
import { galleryImages } from '../data/mock';
import galleryHero from "../assets/images/workwithusBg.webp"

const Gallery = () => {
  const [filter, setFilter] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);

  const filteredImages = filter === 'all'
    ? galleryImages
    : galleryImages.filter(img => img.category === filter);

  return (
    <div className="min-h-screen pt-20">
      {/* Hero */}
      <section className="gradient-hero-saffron py-20"
        style={{
          backgroundImage: `
      linear-gradient(to bottom, rgba(255,247,230,0.85), rgba(192, 119, 51, 0.8)),
      url('${galleryHero}')
    `,
        }}
      >
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center space-y-6">
            <h1 className="text-4xl md:text-5xl font-bold text-foreground font-serif">
              Gallery
            </h1>
            <p className="text-xl text-muted-foreground">
              Glimpses of our journey in preserving and promoting IKS
            </p>
          </div>
        </div>
      </section>

      {/* Filter Tabs */}
      <section className="py-8 bg-white sticky top-20 z-40 shadow-sm">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap justify-center gap-3">
            {['all', 'events', 'media', 'workshops', 'lectures'].map((category) => (
              <button
                key={category}
                onClick={() => setFilter(category)}
                className={`px-5 py-2 rounded-md font-medium text-sm transition-all ${filter === category
                  ? 'bg-primary text-white shadow'
                  : 'bg-secondary/20 text-foreground hover:bg-primary/10'
                  }`}

              >
                {category === 'all' ? 'All' : category.charAt(0).toUpperCase() + category.slice(1)}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            {filteredImages.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {filteredImages.map((item) => (
                  <div
                    key={item.id}
                    className="group relative overflow-hidden rounded-xl shadow-lg hover-lift cursor-pointer"
                    onClick={() => setSelectedImage(item)}
                  >
                    <img
                      src={item.image}
                      alt={item.title}
                      loading='lazy'
                      className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                        <h3 className="text-lg font-bold mb-1">{item.title}</h3>
                        <p className="text-sm text-white/80">{item.date}</p>
                      </div>
                    </div>
                    <div className="absolute top-4 right-4 w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                      <Image className="w-5 h-5 text-white" />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <p className="text-muted-foreground text-lg">No images found in this category</p>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section className="py-16 bg-secondary/20">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-foreground mb-4 font-serif">
                Video Archives
              </h2>
              <p className="text-muted-foreground text-lg">
                Recorded lectures and event highlights
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              {[1, 2].map((item) => (
                <div key={item} className="relative group rounded-xl overflow-hidden shadow-lg hover-lift cursor-pointer">
                  <img
                    src={'/assets/AboutImage.jpeg'}
                    alt="Video thumbnail"
                    className="w-full h-64 object-cover"
                  />
                  <div className="absolute inset-0 bg-black/40 flex items-center justify-center group-hover:bg-black/50 transition-colors">
                    <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
                      <Play className="w-8 h-8 text-primary ml-1" />
                    </div>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6 text-white">
                    <h3 className="font-bold text-lg">Lecture Series {item}</h3>
                    <p className="text-sm text-white/80">IKS in Modern Context</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Image Modal */}
      {/* Image Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 bg-black/90 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div
            className="relative bg-white rounded-xl shadow-2xl max-w-6xl w-full overflow-hidden animate-fade-scale"
            onClick={(e) => e.stopPropagation()}
          >

            {/* Close Button */}
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-4 right-4 z-10 text-white bg-black/60 rounded-full w-10 h-10 flex items-center justify-center text-xl hover:bg-black/80"
            >
              ×
            </button>

            {/* Content Grid */}
            <div className="grid grid-cols-1 md:grid-cols-3">

              {/* IMAGE AREA */}
              <div className="md:col-span-2 bg-black flex items-center justify-center">
                <img
                  src={selectedImage.image}
                  alt={selectedImage.title}
                  className="max-h-[80vh] w-auto object-contain"
                />
              </div>

              {/* TEXT AREA */}
              <div className="p-6 overflow-y-auto max-h-[80vh]">
                <h3 className="text-2xl font-bold text-foreground mb-2">
                  {selectedImage.title}
                </h3>
                <p className="text-sm text-muted-foreground mb-4">
                  {selectedImage.date}
                </p>

                {selectedImage.description && (
                  <p className="text-muted-foreground leading-relaxed">
                    {selectedImage.description}
                  </p>
                )}
              </div>

            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Gallery;
